import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '@tsin-shared/components/footer/footer.component';
import { MainHeaderComponent } from '@tsin-shared/components/main-header/main-header.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, FormsModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'TSIN2024_PRO_FrontEnd';
}
